// extracted by mini-css-extract-plugin
module.exports =  {"tag":"TagDestructive-module__tag___YPIpD"};